import { Button } from "@/components/ui";

type Props = {
  hasPrev: boolean;
  hasNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  showActions: boolean;
  required: boolean;
  hidden: boolean;
  linkMode: boolean;
};

export function ReviewDrawerFooter({
  hasPrev,
  hasNext,
  onPrev,
  onNext,
  showActions,
  required,
  hidden,
  linkMode,
}: Props) {
  return (
    <footer className="flex shrink-0 flex-wrap items-center justify-between gap-2 border-t border-slate-200 bg-white px-[18px] py-3 dark:border-slate-800 dark:bg-slate-900">
      <span className="text-xs text-slate-500 dark:text-slate-400">
        {showActions && hidden
          ? "Save keeps it hidden."
          : required && showActions && !linkMode
            ? "Required. It cannot be ignored."
            : "Changes stay in this browser until you save."}
      </span>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={!hasPrev}
          onClick={onPrev}
        >
          Previous
        </Button>
        <Button
          variant="outline"
          size="sm"
          disabled={!hasNext}
          onClick={onNext}
        >
          Next
        </Button>
      </div>
    </footer>
  );
}
